import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type {
  PostCustomerSubscriptionEstimates,
  PostSendSubscriptionPeriodDocument,
} from "@/server-types";

type MissingDocumentReason = NonNullable<
  PostSendSubscriptionPeriodDocument["response"]["missingDocumentReason"]
>;

type BillingDocumentDelivery =
  PostCustomerSubscriptionEstimates["response"]["memberNotifications"][number]["delivery"];

export const BILLING_DOCUMENT_OFF_HINT = msg`Najprej vklopite obvestilo »Dokument obdobja« v Nastavitve › Obvestila.`;

/** Why a sent Billing document notification went out without the period's document. */
export const MISSING_DOCUMENT_REASON: Record<
  MissingDocumentReason,
  MessageDescriptor
> = {
  memberOwesNothing: msg`Stranka za to obdobje ne dolguje ničesar.`,
  paidWithoutInvoice: msg`Obdobje je plačano brez računa.`,
  issuingOff: msg`Paket nima vklopljenega izdajanja predračunov.`,
  taxRegisterNotSetUp: msg`Davčna blagajna ni nastavljena.`,
  periodNotFound: msg`Obdobja ni bilo mogoče najti.`,
  documentUnavailable: msg`Dokumenta ni bilo mogoče prebrati.`,
};

/** Why the Billing document notification after a manual issue did not reach the customer. */
export const UNSENT_DELIVERY: Record<
  Exclude<BillingDocumentDelivery, "sent">,
  MessageDescriptor
> = {
  notificationOff: msg`Obvestilo »Dokument obdobja« je izklopljeno.`,
  noContact: msg`Stranka nima e-pošte ali telefonske številke.`,
  noChannel: msg`Obvestilo »Dokument obdobja« nima kanala, ki bi dosegel stranko.`,
  failed: msg`Obvestila ni bilo mogoče poslati.`,
};
